import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class NewsGuard implements CanActivate {

  constructor(public configService: ConfigService) {}

  async canActivate(): Promise<boolean> {
    await this.configService.getInitialInfo().then((response) => {
      return response;
    });
    let modulesEnabled = await this.configService.company_info.modules_enabled;
    if (modulesEnabled) {
      if (modulesEnabled.includes('NEWS')) {
        return true;
      } else {
        return false;
      }
    }
  }

}
